import React, { useState } from 'react'
import { Button, ButtonTag } from 'components/Form'
import { I18n } from 'react-redux-i18n'
import ModalWrapper from 'components/ModalWrapper'
import { getStaticImage } from 'utils/statics'
import NormalModal from '../ChatMail/AddAccountModals/NormalModal'
import ImapModal from '../ChatMail/AddAccountModals/ImapModal'
import DelegateModal from '../ChatMail/AddAccountModals/DelegateModal'
import ChatmailBeta from 'components/ChannelView/ChatmailBeta'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const AddAccount = (props) => {
  const { label, onSubmit, onChange, schema, channel } = props
  const [ isOpenModalAccountType, setIsOpenModalAccountType ] = useState(false)
  const [ mailProvider, setMailProvider ] = useState(null)
  const [ isOpenModalDelegate, setIsOpenModalDelegate ] = useState(false)
  const [ isOpenModalNormal, setIsOpenModalNormal ] = useState(false)
  const [ isOpenModalImap, setIsOpenModalImap ] = useState(false)

  const providers = [
    { key: 'gmail', label: lang('channels_gmail'), type: 'delegate', order: 0, disabled: false },
    { key: 'imap', label: lang('dashboard_other'), type: 'imap', order: 1, disabled: false },
    { key: 'blank', label: '', type: '', order: 2, disabled: false },
    { key: 'office360', label: lang('channels_office-365'), type: 'delegate', order: 3, disabled: false },
    { key: 'outlook', label: lang('channels_outlook'), type: 'delegate', order: 4, disabled: false },
    { key: 'exchange', label: lang('channels_exchange'), type: 'delegate', order: 5, disabled: false },
    { key: 'imap_yahoo', label: lang('channels_imap_yahoo'), type: 'normal', order: 6, disabled: false, help: 'https://help.yahoo.com/kb/generate-separate-password-sln15241.html', link: 'https://login.yahoo.com/account/security?.lang=en-US&.intl=us&.src=yhelp' },
    { key: 'imap_icloud', label: lang('channels_imap_icloud'), type: 'normal', order: 7, disabled: false, help: 'https://support.apple.com/es-es/HT204397', link: 'https://appleid.apple.com/account/home' },
    { key: 'imap_aol', label: lang('channels_imap_aol'), type: 'normal', order: 8, disabled: false, help: 'https://help.aol.com/articles/Create-and-manage-app-password', link: 'https://login.aol.com/myaccount/security/?lang=en-US&scrumb=eF.0YRbm0f7' },
  ]

  const onClickAccountType = (account) => {
    if (account.disabled) return
    setMailProvider(account)
    if (account.type === 'delegate') setIsOpenModalDelegate(true)
    if (account.type === 'normal') setIsOpenModalNormal(true)
    if (account.type === 'imap') setIsOpenModalImap(true)
    setIsOpenModalAccountType(false)
  }

  const onSave = async (data) => {
    let result = null
    try {
      result = await onSubmit()
    } catch (error) {
      console.error(error)
    }
    return new Promise((resolve, reject) => {
      if (result) return resolve(result)
      else return reject(null)
    })
  }

  const onChangeLocal = (data) => {
    onChange(mailProvider.key, 'key')
    _.forEach(data, (value, key) =>{
      onChange(value, `value.${key}`)
    })
  }

  return (
    <div className={`channel-field add-acount ${channel?.isNew || !channel?.value?.email ? '' : 'edit-account'}`}>
      {
        channel?.isNew || !channel?.value?.email
          ?
          <div>
            <Button primary value={I18n.t(label)} onClick={()=>setIsOpenModalAccountType(true)} className='button-medium' />
          </div>
          :
          <div className='with-value'>
            <img className={`account-${channel?.key}`} alt={channel.key} src={getStaticImage(`/icons/orange-brand/icon-${channel.key === 'imap_yahoo' ? 'yahoo' : channel.key === 'imap_icloud' ? 'icloud' : channel.key === 'imap_aol' ? 'aol' : channel.key}.png`)}/>
            <label>{channel?.value?.email}</label>
            <ButtonTag
              className='account-button-tag'
              value={I18n.t('dashboard_edit')}
              onClick={()=>onClickAccountType(providers.find(it => it.key === channel.key))}
            />
          </div>
      }
      <ModalWrapper
        id={'modalAccountType'}
        header={I18n.t('dashboard_new-account')}
        body={
          <div className='account-type-modal'>
            <h2>{I18n.t('dashboard_select-provider')}</h2>
            <div className='account-type-wrapper'>
              {
                providers.map((it, idx) => {
                  const _key = it.key === 'imap_yahoo' ? 'yahoo' : it.key === 'imap_icloud' ? 'icloud' : it.key === 'imap_aol' ? 'aol' : it.key
                  if (it.key === 'blank') {
                    return (
                      <div key={`key-${idx}`} className={`account-button ${it.disabled ? 'disabled' : ''} blank`}>
                        {/* <img className={`account-${_key}`} alt={_key} src={getStaticImage(`/icons/orange-brand/icon-${_key}.png`)}/>
                        <label>{it.label}</label> */}
                      </div>
                    )
                  }
                  else {
                    return (
                      <div key={`key-${idx}`} className={`account-button ${it.disabled ? 'disabled' : ''}`} onClick={()=>onClickAccountType(it)}>
                        <img className={`account-${_key}`} alt={_key} src={getStaticImage(`/icons/orange-brand/icon-${_key}.png`)}/>
                        <label>{it.label}</label>
                        <div className='wrapper-beta'>{it.disabled ? <ChatmailBeta text={I18n.t('dashboard_available-soon')}/> : null}</div>
                      </div>
                    )
                  }
                })
              }
            </div>
          </div>
        }
        isOpen={isOpenModalAccountType}
        toggle={()=>setIsOpenModalAccountType(!isOpenModalAccountType)}
        showClose={true}
      />
      <DelegateModal
        mailProvider={mailProvider}
        isOpen={isOpenModalDelegate}
        toggle={()=>setIsOpenModalDelegate(!isOpenModalDelegate)}
        onChange={onChangeLocal}
        schema={schema}
        onSubmit={onSave}
        channel={channel}
      />
      <NormalModal
        mailProvider={mailProvider}
        isOpen={isOpenModalNormal}
        toggle={()=>setIsOpenModalNormal(!isOpenModalNormal)}
        onChange={onChangeLocal}
        schema={schema}
        onSubmit={onSave}
        channel={channel}
      />
      <ImapModal
        mailProvider={mailProvider}
        isOpenModalNormal={isOpenModalImap}
        toggle={()=>setIsOpenModalImap(!isOpenModalImap)}
        onSubmit={onSave}
        onChange={onChangeLocal}
        schema={schema}
        channel={channel}
      />
    </div>
  )
}

export default AddAccount